/* Using a plain function instead of an arrow function, 
   so Alpine can bind a custom this context 
   when it initially evaluates the component scope */

const favourites = function () {
  return {
    ids: this.$persist([]).using(cookieStorage).as("rgf_favourites"),
    favourites: [],
    init() {
      this.$watch("ids", () => {
        this.$dispatch("favourited", { data: this.count });
      });
    },

    load() {
      fetch("/_ajax/favourites")
        .then((response) => response.json())
        .then((data) => {
          this.favourites = data;
        });
    },

    add(id) {
      if (!this.ids.includes(id)) {
        this.ids.push(id);
      }
    },

    remove(id) {
      this.ids = this.ids.filter((x) => x !== id);
    },

    contains(id) {
      return this.ids.includes(id);
    },

    clear() {
      this.ids = [];
    },

    animatePing(el, animationClass = "animate-ping-once") {
      el.classList.remove(animationClass);
      setTimeout(() => el.classList.add(animationClass), 0);
    },

    get count() {
      return this.ids.length;
    },
  };
};

export { favourites };
